/* eslint-disable */
import React from 'react';
import Card from '@material-ui/core/Card';
import photo from '../images/philantrophy-slider/jim.jpg';

/**
 * This function renders the InvestorRelations page
 * @component InvestorRelations
 * @return {Component} InvestorRelations component
 */
export default function InvestorRelations() {
  return (
    <Card
      style={{
        padding: '50px',
        width: '1200px',
        margin: '30px auto 30px auto',
      }}
    >
      <div style={{borderBottom: '1px solid silver', paddingBottom: '5px'}}>
        <h1 style={{paddingBottom: '2px'}}>
          The True Metaverse: Metabolic Physics
        </h1>
      </div>
      <h2>Introduction</h2>
      <p>
        Twenty-first century characterizations of organic bodies account for the
        biologic definition of living molecular constellations. In the general
        study of biophysics, metabolic physics emerges as a separate field of
        research explaining the physical development and kinetic action-motion
        of organic bodies, and the expression of quasi-physical energy inherent
        to these bodies, an essential knowledge for today’s skilled and novice
        defense specialists, biodefense product and service contractors, as well
        as metabolic physics information technology hardware and application
        manufacturers, to better understand and protect core asset integrity,
        before, during, and after indications of disabling metabolic physics
        attacks.
      </p>
      <div style={{height: '10px'}} />
      <h2>Origins & Basic Principles of Meta</h2>
      <p>
        Publicly speaking, “meta” has become a popular cultural catchword,
        recently rooted in the information technology world as a digital virtual
        environment called the Metaverse.
      </p>
      <p>
        Meta is actually short for metabolic, or the physical expression process
        of life by and which all methods of the organic Universe are dependent
        on, including, but not limited to, precelluar structure, dynamic
        cellular regeneration, reproduction, aging, as well as the physical
        protocols of common human physical, and mental health.{' '}
      </p>
      <p>
        In it’s purest state, metabolic physics is the field of study pertaining
        to the sourceology and infrastructure of biological energy algorithms
        responsible for installing the unique properties of organic life into
        physical D.N.A. Why is this field of information so essential for
        today’s biodefense specialists?{' '}
      </p>
      <p>
        As many biodefense experts know, prowess and productivity are the
        ultimate costs of tolerating metabolic physics warfare and abuse
        negligence, aimed primarily against the United States and it’s national
        security goals, objectives, and tasks worldwide. The integrity of public
        U.S. Government operations could be impacted by the effects of metabolic
        terrorism, short- and long-term. Now is the time to make that assessment
        and determine if additional resources are necessary to identify,
        isolate, and neutralize nation-state sponsored attacks, before they
        materialize.
      </p>
      <div style={{height: '10px'}} />
      <h3 style={{fontSize: '22px'}}>Biodefense Initiatives</h3>
      <p>
        National metabolic biodefense is a critical preventive security
        objective. At A.I.S., core asset defense is defined down to the state of
        metabolic physics, personal biophysical integrities, and the asset’s
        application to environmental physics, such as land, sea, or space. Over
        the next twenty years, biological defense initiatives will likely
        delegated to biodata servers, meta-space neurodefense applications, and
        the critical role law enforcement will play in recognizing and
        protecting against public fraud and other high-biotechnology related
        crimes, such as touchless harassment or murder.
      </p>
      <div style={{height: '10px'}} />
      <h3 style={{fontSize: '22px'}}>Metabolic Warfare</h3>
      <p>
        Disorienting and bizarre on the senses, metabolic warfare can alter the
        state of U.S. labor workers, professionals, politicians and military
        personnel worldwide. According to field data, sophisticated metabolic
        physics warfare and terrorism is on the rise in 2022, and will present
        increasingly complex, less detectible attacks on personal or collective
        natural and advanced artificial metabolic physics networks, ongoing in
        the continued absence of domestic and international educational support
        materials required to counter disfunction in most military and civilian
        biodefense contexts. Bottom line: If you suspect metabolic warfare in
        military or political operating contexts, say something to a military
        official-representative.
      </p>
      <div style={{height: '10px'}} />
      <h3 style={{fontSize: '22px'}}>Education & Strategy</h3>
      <p>
        Knowledge is power. The key to a successful multi-circa biodefense
        strategy is communicating the right information to long-term defense
        contributors. Leave timing and security protocols for artificial
        intelligence applications of the future to solve. In 2022, manage your
        military organization management experience with fundamental tactical
        content that empowers personnel as operations progress, naturally
        improving morale and increasing biophysical compatibility with viable,
        lasting outcomes.
      </p>
      <div style={{height: '10px'}} />
      <h3 style={{fontSize: '22px'}}>
        Funding Private Metabolic Physics Research
      </h3>
      <p>
        Metabolic physics warfare is a serious threat to the American people,
        and a primary research focus of the Advanced Intelligence Services
        Corporation. Military must act swiftly. A.I.S. requires immediate
        funding to supplement existing research and development operations,
        multi-circa. Purchasing an information product or service is the easiest
        way to fund A.I.S. today, however military funding programs are also
        accepted. Cryptocurrency agreements may be applicable, in certain
        funding contexts. To get started, call toll-free: 1-800-427-9479, or
        e-mail: services@aisincorporated.com.
      </p>
      <div style={{height: '10px'}} />
      <h2>Expert Analysis</h2>
      <img
        style={{float: 'right', margin: '0 auto'}}
        width="250px"
        src={photo}
      ></img>
      <p>
        Jim D. Ray, Founder & C.E.O. of the Advanced Intelligence Services
        Corporation, researched metabolic physics infrastructure for nearly two
        decades as the meta culture spread across the United States, and
        metabolic physics warfare came to our shores. Ray is a devoted expert in
        the field of biotechnology with countless hours of live-time multi-circa
        experience managing biodefense research operations in volatile
        international meta-space.
      </p>
      <p>
        In a recent interview, Jim D. Ray wrote: “Protecting assets against
        metabolic physics warfare is a challenging, and complex task. It
        requires multi-tasking organization, strategic planning, environment
        acceptance, and recognizing the reality that meta warfare is too
        alluring to our enemies to ignore. It will continue to be a problem,
        nationally and internationally, and we must address that threat on the
        front-end, beginning with the end in mind. Meta terrorism is obviously
        state-sponsored, and they won’t stop until they get busted. Military’s
        evolving goals, and objectives aren’t too complicated; simple stated,
        we, and our long-term allies intend to win the war on biodefense. Anyone
        left is an opponent of freedom and peace. This is a very serious
        conversation that should not be ignored, yet must be approached in a
        most skillful way. After all, who actually knows where meta tech was
        introduced to humanity psychologically, or why natural metabolic physics
        relay was historically disabled. Like most technology, meta hardware is
        a crutch that enables humans to live do more of what they can, to live
        life, to it’s maximum extent. A.I.S. will offer it’s experience in the
        form of safe information technology products that regard the effects of
        interdependent military and public outcomes carefully, while conducting
        ethically responsible research throughout the next several decades.”
        (July 2022)
      </p>
    </Card>
  );
}
